(function ($, Drupal, drupalSettings) {
  //Add sup tag for site special character
  $('body :not(script)').contents().filter(function() {
    return this.nodeType === 3;
  }).replaceWith(function() {
    return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
  });

  //Open the menu search
  $('#search').click(function () {
    closelanguageswitcher();
    closemenu();
    $('.custom-search-block-form form').toggle();
  });

  var closemenu = function (){
    if($('#superfish-main-toggle').hasClass('sf-expanded')){
      $('#superfish-main-toggle').trigger("click");
    }
  };
  var closelanguageswitcher = function (){
    if($('#activeLangDropdown').hasClass('open')){
      $('#activeLangDropdown').trigger("click");
    }
  }
  var closesearchbar =function (){
    $('.custom-search-block-form form').hide();
  }

  $(".superfish-navigation").click(function(){
    $(".custom-search-block-form form,.language-switcher-language-url .links").hide();
    $(".language-switcher-language-url .toggle-button").removeClass('open')
  })
  //Open the Pflichtangaben popup
  $(".required-information-block h6").on("click",function(){
    $(this).next().slideToggle();
    $('body').addClass('modal-open');
  });

  //close the Pflichtangaben popup
  $(".required-information-content h2 span").on("click",function(){
    $('.required-information-content').slideToggle();
    $('body').removeClass('modal-open');
  });

  //Prepend the button in cookies for opening the secondary popup
  setTimeout(function(){
    $('.secondary-popup').click(function () {
      $('body').addClass('modal-open secondary-popup-open')
    });

    //Prepend close popup button
    $('.eu-cookie-compliance-categories,.eu-cookie-withdraw-banner .popup-content').prepend('<button class="close-popup"><span class="bioIcon-cross"></span></button>');

    $('.agree-button,.eu-cookie-compliance-save-preferences-button').click(function () {
      setTimeout(function(){
        $('.eu-cookie-withdraw-banner .popup-content').prepend('<button class="close-popup"><span class="bioIcon-cross"></span></button>');
      }, 3000);
    })

    //Hide withdraw consent popup
    $(document.body).on('click','.close-popup',function () {
      $('#sliding-popup').animate({top:'-100%'}, 1400);
    })

    //Remove the modal-open and secondary-popup-open classes
    $('.eu-cookie-compliance-save-preferences-button,.eu-cookie-compliance-categories .close-popup').click(function () {
      $('body').removeClass('modal-open secondary-popup-open');
    });
  }, 1000);

  //Get Pflichtangaben param from url
  function getPflichtangabenParam() {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    // get the required parameter
    var param = urlParams.get('pflichttext'); // returns the value of parameter 'lan'
    return param;
  }

  //Open the Pflichtangaben popup if url has pflichttext param true
  if (getPflichtangabenParam()){
    $('body').addClass('modal-open');
    $('.required-information-content').slideToggle();
  }


// Function for hide show elements
  var hideShow =  function(className) {
    var x = document.getElementsByClassName(className)[0];
    if (x.style.display === 'none') {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
  }
  $(window).on('load', function () {
    if(jQuery('.section-space .bionorica_breadcrums').length > 0) {
      jQuery('.section-space .bionorica_breadcrums').insertAfter('header')
    }


    var langExist = document.getElementsByClassName('language-switcher-language-url')[0];
    console.log(langExist);
    if(langExist){
      var langLinks = document.querySelectorAll('.language-switcher-language-url .links')[0].childElementCount;
      //Change english text with en in language dropdown
      if(langLinks && langLinks > 1 ) {
        var engDropdownItem = document.getElementsByClassName('en');
        if(engDropdownItem.length > 0)
          engDropdownItem[0].children[0].innerHTML = 'EN';

        //Add active lang div
        var activeLang = document.getElementsByClassName("language-link is-active")[0].innerHTML;
        var activeLangDiv = document.createElement("DIV");
        activeLangDiv.id = "activeLangDropdown";
        activeLangDiv.classList = "toggle-button";
        var textnode = document.createTextNode(activeLang);
        activeLangDiv.appendChild(textnode);
        document.getElementsByClassName("language-switcher-language-url")[0].appendChild(activeLangDiv);
        activeLangDropdown.onclick = function(){
          var dropdownToggle = document.getElementById('activeLangDropdown');
          dropdownToggle.classList.toggle('open');
          var langDropdown = document.getElementsByClassName('links')[0];
          langDropdown.style.display === "none";
          if (langDropdown.style.display === "none") {
            langDropdown.style.display = "block";
          } else if(langDropdown.style.display === "block"){
            langDropdown.style.display = "none";
          } else {
            langDropdown.style.display = "block";
          }
          $('.custom-search-block-form form').css({'display': 'none'});
        }
        //Add a class if language dropdown exist
        document.getElementsByClassName('layout-header')[0].classList = "layout-header lang-added";
      }else {
        document.getElementsByClassName("language-switcher-language-url")[0].style.display = "none";
      }
    }
  });
// sticky disclaimer for russia
  var stickyDisclaimer = function () {
    var stickyDisclaimer =  document.getElementsByClassName('sticky-disclaimer')
    if(stickyDisclaimer.length)
      document.getElementsByTagName('body')[0].style.paddingBottom = stickyDisclaimer[0].scrollHeight - 20 + 'px';
  }
  stickyDisclaimer();
  window.addEventListener('resize' , function () {
    stickyDisclaimer();
    winWidth();

    if(winWidth() > 767) {
      customBreadcrumb();
    }else if((winWidth() < 768 && jQuery('.breadcurmbs-dropdown').length < 1)){
      customBreadcrumb();
    }
    headerTopSpace()
  });

  var winWidth = function() {
    //note i need to pass the event as an argument to the function
    width = window.innerWidth;
    return width;
  }
  winWidth();

  //Body padding top according to header height
  function headerTopSpace() {
    if(winWidth() > 1024) {
      var headerHeight = document.getElementsByTagName('header')[0].clientHeight.toString();
      document.getElementsByTagName('body')[0].style.paddingTop = headerHeight + 'px';
    }else {
      document.getElementsByTagName('body')[0].removeAttribute('style');
    }
  }
  headerTopSpace();


  var breadcrumb = document.querySelectorAll('.bionorica_breadcrums ol');

  var customBreadcrumb = function () {
    if(breadcrumb.length > 0 && winWidth() < 768 && breadcrumb[0].children.length > 2){
      breadcrumb[0].classList.add('add-dots');
      //Add breadcurmbs for mobile
      // create a new li node
      var li = document.createElement('li');
      li.textContent = '';
      // insert a new node after the first list item
      breadcrumb[0].insertBefore(li, breadcrumb[0].firstElementChild.nextSibling);
      // Create a clone of element with id ddl_1:
      var clone = document.querySelector('.bionorica_breadcrums ol').cloneNode( true );
      // Change the id attribute of the newly created element:
      clone.setAttribute( 'class', 'breadcurmbs-dropdown' );
      clone.setAttribute( 'style', 'display: none;');
      // Append the newly created element on element p
      document.querySelector('.bionorica_breadcrums nav').appendChild( clone );
    }else{
      if(document.querySelectorAll('.breadcurmbs-dropdown').length > 0 && winWidth() > 767){
        document.querySelectorAll('.breadcurmbs-dropdown')[0].remove();
        document.querySelectorAll('.bionorica_breadcrums ol li:nth-child(2)')[0].remove();
      }
    }
  }
  customBreadcrumb();

  if(breadcrumb.length > 0){
    if( breadcrumb[0].childElementCount > 2) {
      document.querySelectorAll(".bionorica_breadcrums ol li:nth-child(2)")[0].addEventListener('click',function (event) {
        hideShow('breadcurmbs-dropdown');
      });
    }
  }

//Cookies professional
  if(jQuery('.disclaimer-confirmation').length > 0){
    jQuery('.disclaimer-confirmation .btn.btn-primary').click(function(){
      setCookie('isDisclaimer','true',30);
      jQuery('body').removeClass('popupOpend');
      jQuery('.disclaimer-confirmation').hide();
    })

    function setCookie(cname,cvalue,exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function checkCookie() {
      var user=getCookie("isDisclaimer");
      if (user == "true") {
        jQuery('body').removeClass('popupOpend');
        jQuery('.disclaimer-confirmation').hide();
      }else {
        jQuery('body').addClass('popupOpend');
        jQuery('.disclaimer-confirmation').show();
      }
    }

    checkCookie()
  }

  var currentHost = location.hostname;
  var reg_exp = new RegExp(currentHost);

  $('header li a').each(function() {
    if (!reg_exp.test(this.href)) {
      $(this).attr('rel','nofollow');
    }
  });

  var addIndex = function (){
    $('.paragraph').each(function(index){
      var paraGraphId = $(this).attr('id')
      $(this).attr('id',paraGraphId + '_' + index);
    })
  }
  addIndex();

  jQuery('.click-email').click(function(){
    var mail = window.atob(jQuery('.email-content').data('ema'));
    jQuery('.email-content').html(mail);
    jQuery('.email-content').attr('href','mailto:'+mail);

    jQuery('.stars,.click-email').hide();
    jQuery('.email-content').show();
  })
})(jQuery, Drupal, drupalSettings);

/**
 * Loop over the paragraph modules and add indexes to the edit link
 */
(function ($) {
  'use strict';

  $('div.paragraph').each(function (i, obj) {

    var paragraph = $(obj);
    var editLink = paragraph.find('a.current-node-link');

    if (editLink[0]) {
      var editLinkHref = editLink.attr('href');

      editLink.attr('href', editLinkHref + '__' + i);
    }

  });

})
(jQuery);
// To add animation on paragraph content text
(function ($) {
  jQuery(".animate_fade_up").attr({
    "data-aos":"fade-up",
    "data-aos-once":"true",
    "data-aos-duration":"1000",
    "data-aos-delay":"200",
  });
})(jQuery);

jQuery(document).ready(function (){
  if(jQuery('.blog-main-column').length){
    var mainArticleSection = jQuery('.blog-main-column').offset().top;
    jQuery('.progress').css('top', mainArticleSection);
  }
  jQuery(function(){
    var current = location.pathname;
    jQuery('.tag-block-container li').each(function(){
      var $this = jQuery(this).find('a');
      // if the current path is like this link, make it active
      if($this.attr('href') == current){
        $this.addClass('activelink');
      }
    })
  })
  if(jQuery('.most-read-block ul').length){
    jQuery('.most-read-block ul').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      arrows: false
    });
  }
  jQuery('.authors-section li').click(function(){
    jQuery(this).prependTo('.authors-section ul');
  })
  jQuery(function(){

    var $bannerContent = jQuery('.banner-content');
    var $banner = jQuery('.banner');

    var $window = jQuery(window).on('resize', function(){
      var height = $bannerContent.height() + 60;
      $banner.css('min-height',height);
    }).trigger('resize'); //on page load

  });

  jQuery(function(){
    var $bannerContent = jQuery('.product-slide-content');
    var $banner = jQuery('.product-banner-module');

    var $window = jQuery(window).on('resize', function(){
      var height = $bannerContent.height() + 60;
      $banner.css('min-height',height);
    }).trigger('resize'); //on page load

  });
})

var h = document.documentElement,
  b = document.body,
  st = 'scrollTop',
  sh = 'scrollHeight',
  progress = document.querySelector('.progress'),
  scroll;

if(progress){
  document.addEventListener('scroll', function() {
    scroll = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
    progress.style.setProperty('--scroll', scroll + '%');
  });
}

//fixed header correction
(function($, window) {
  var adjustAnchor = function() {
    var $anchor = $(':target'),
      fixedElementHeight = 30;
    if ($anchor.length > 0) {
      $('html, body')
        .stop()
        .animate({
          scrollTop: $anchor.offset().top - fixedElementHeight
        }, 200);
    }
  };
  $(window).on('hashchange load', function() {
    adjustAnchor();
  });
})(jQuery, window);
